import Button, { ButtonProps } from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import React from 'react';

type StartButtonVariant = 'primary' | 'secondary';

interface StartButtonProps extends ButtonProps {
  children: React.ReactNode;
  variantType?: StartButtonVariant;
  endIcon?: React.ReactNode; 
}

const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'variantType',
})<StartButtonProps>(({ theme, variantType }) => {
  const baseStyle = {
    border: '5px solid white',
    borderRadius: '50px',
    fontFamily: 'Lexend Exa, sans-serif',
    fontWeight: 'bold',
    padding: '10px 24px',
    textTransform: 'uppercase' as const,
    width: 'fit-content',
    boxShadow: 'inset 0 0 0 1px #4D0042',
    '.MuiButton-endIcon': {
      marginLeft: '12px',
    },
  };

  if (variantType === 'secondary') {
    return {
      ...baseStyle,
      backgroundColor: 'var(--EGGSHELL)',
      border: '3px solid var(--PURPLE)',
      color: 'var(--PURPLE)',
      '&:hover': {
        backgroundColor: 'var(--PURPLE) !important',
        color: 'white !important',
        borderColor: 'var(--PURPLE) !important',
      },
    };
  }

  // primary (default)
  return {
    ...baseStyle,
    backgroundColor: '#A9A0F8', // ton violet clair actuel
    border: '5px solid white',
    color: '#4D0042', // violet foncé
    '&:hover': {
      backgroundColor: 'white !important',
      borderColor: '#A9A0F8 !important',
      color: '#4D0042 !important',
    },
  };
});

const StartButton: React.FC<StartButtonProps> = ({
  children,
  variantType = 'primary',
  endIcon,
  ...props
}) => {
  return (
    <StyledButton {...props} variantType={variantType} endIcon={endIcon}>
      {children}
    </StyledButton>
  );
};

export default StartButton;
